import React, { useState } from 'react';
import axios from 'axios';
import { baseUrl } from '../../../Utils/Baseurl/Baseurl';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

export default function Tax() {
  const [taxpercent, setTaxpercent] = useState<number | string>('');
  const [message, setMessage] = useState<string | null>(null);
  const navigate = useNavigate(); // ✅ Use navigate for redirection

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${baseUrl}tax/addtax`, { taxpercent });
      console.log(response, 'res');
      setMessage(response.data.message);
      
      // ✅ Show success toast
      toast.success("Tax added successfully!", {
        position: "top-center",
        autoClose: 2000, // 2 seconds
      });

      // ✅ Navigate after 2 seconds
      setTimeout(() => {
        navigate('/viewtax');
      }, 2000);
      
    } catch (error) {
      setMessage("Failed to add tax");
      toast.error("Failed to add tax");
      console.error(error);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '400px', margin: 'auto' }}>
      <h2>Enter Tax Percentage</h2>
      <form className="theme-form" onSubmit={handleSubmit}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
          <label style={{ flex: '0 0 50%' }}>Tax</label>
          <input
            type="number"
            value={taxpercent}
            onChange={(e) => setTaxpercent(e.target.value)}
            placeholder="Enter tax %"
            style={{ flex: '1', padding: '8px' }}
            required
          />
        </div>
        <button type="submit" style={{ padding: '8px 15px', cursor: 'pointer' }}>
          Submit
        </button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
}
